import { render, staticRenderFns } from "./TheArticleList.vue?vue&type=template&id=10500104&scoped=true&"
import script from "./TheArticleList.vue?vue&type=script&lang=js&"
export * from "./TheArticleList.vue?vue&type=script&lang=js&"
import style0 from "./TheArticleList.vue?vue&type=style&index=0&id=10500104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10500104",
  null
  
)

export default component.exports